// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { ButtonStylesClassesType } from "../../styles/buttonStyles";
import { buttonStyles } from "../../styles/buttonStyles";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...buttonStyles(theme),
  root: {
    display: "inline-flex",
    flexDirection: "row",
    verticalAlign: "baseline"
  },
  button: {
    flex: "1 0 auto",
    margin: "0",
    borderRadius: "0"
  },
  firstChild: {
    borderTopLeftRadius: "0.5rem",
    borderBottomLeftRadius: "0.5rem"
  },
  lastChild: {
    borderTopRightRadius: "0.5rem",
    borderBottomRightRadius: "0.5rem"
  },
  indicatorSpace: {
    position: "relative",
    height: "2.57142857em",
    zIndex: "3",
    margin: "0.2em"
  },
  indicator: {
    "&:before": {
      position: "absolute",
      textAlign: "center",
      borderRadius: "500rem",
      content: "'or'",
      top: "50%",
      left: "50%",
      backgroundColor: "#fff",
      textShadow: "none",
      marginTop: "-0.68em",
      marginLeft: "-.89285714em",
      width: "1.78571429em",
      height: "1.78571429em",
      lineHeight: "1.68em",
      color: "rgba(0,0,0,.4)",
      fontStyle: "normal",
      fontWeight: "700",
      boxShadow: "0 0 0 1px transparent inset"
    }
  }
});

type ButtonSelectStatesType = {
  selected: string | boolean
};

type ButtonType = {
  value: string | boolean,
  label: string
};

type ButtonSelectClassesType = {
  ...ButtonStylesClassesType,
  root: DictionaryType,
  button: DictionaryType,
  indicatorSpace: DictionaryType,
  indicator: DictionaryType
};

type ButtonSelectPropsType = {
  classes: ButtonSelectClassesType,
  value: string | boolean,
  handleChange: Function,
  name: string,
  buttons: Array<ButtonType>,
  noIndicator?: boolean
};

class ButtonSelect extends Component<
  ButtonSelectPropsType,
  ButtonSelectStatesType
> {
  constructor(props: ButtonSelectPropsType) {
    super(props);
    this.state = {
      selected: props.value
    };
  }

  componentDidUpdate(prevProps: ButtonSelectPropsType) {
    if (prevProps.value !== this.props.value) {
      this.setState({ selected: this.props.value });
    }
  }

  buttonSelect = (value: string | boolean): * => {
    this.setState({ selected: value }, () => {
      this.props.handleChange(this.props.name, value);
    });
  };

  render(): * {
    const classes = this.props.classes;
    const buttonLength = this.props.buttons.length;

    const buttonList = this.props.buttons.map(
      (button: ButtonType, i: number): * => {
        return (
          <div key={"button" + i}>
            <Button
              color={
                this.state.selected === button.value ? "primary" : "default"
              }
              variant="contained"
              type="button"
              className={classNames(
                classes.button,
                i === 0 && classes.firstChild,
                i + 1 === buttonLength && classes.lastChild,
                this.state.selected === button.value && classes.darkBtn
              )}
              onClick={(): * => this.buttonSelect(button.value)}
            >
              {button.label}
            </Button>
            {buttonLength !== i + 1 && (
              <span
                className={classNames(classes.indicatorSpace, {
                  [classes.indicator]: !this.props.noIndicator
                })}
              />
            )}
          </div>
        );
      }
    );
    return <div className={classes.root}>{buttonList}</div>;
  }
}

export default withStyles(styles)(ButtonSelect);
